"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameClasses = exports.gameClasses = void 0;
exports.gameClasses = {
    Memes: ['Memes'],
    'Movies+TV': ['Movies+TV', 'Metaverse'],
    Festive: ['Easter', 'Halloween', 'NewYears', 'Xmas', 'monKeyversary'],
};
var GameClasses;
(function (GameClasses) {
    GameClasses["Memes"] = "Memes";
    GameClasses["MoviesTV"] = "Movies+TV";
    GameClasses["Festive"] = "Festive";
})(GameClasses = exports.GameClasses || (exports.GameClasses = {}));
